<script setup lang="ts">
import { computed } from 'vue'
import TextView from '@/ui/common/text-view/TextView.vue'
import LibraryCardGroup from '@/ui/common/library/library-card-group/LibraryCardGroup.vue'
import { IAgent, IAgentsByCategory } from '@/api/modules/task-library/types'

interface Props {
  data: IAgentsByCategory
}

interface Emits {
  (e: 'showmore', param: any): void
}

const emit = defineEmits<Emits>()

const props = defineProps<Props>()
const keys = computed(() =>
  Object.keys(props.data)
    .sort()
    .filter((k) => props.data[k].items?.length > 0),
)

const handleShowMore = async ({ category }: any) => {
  emit('showmore', { category })
}
</script>

<template>
  <div class="LibraryCardGrid">
    <div v-for="key in keys" :key="key">
      <TextView variant="roboto_18_bold" color="gray_100" class="LibraryCardGrid__groupName">
        {{ props.data[key].items[0]?.category?.label }}
      </TextView>
      <LibraryCardGroup
        :items="props.data[key].items"
        :key="key"
        :has-more="props.data[key].next !== null"
        @showmore="handleShowMore({ category: key })"
      />
    </div>
  </div>
</template>
<style lang="css" scoped>
.LibraryCardGrid {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 56px;
}

.LibraryCardGrid__groupName {
  margin-bottom: 24px;
}
</style>
